import userdetails from './userdetails'

export default {userdetails}